import { render, staticRenderFns } from "./OrderSuccess.vue?vue&type=template&id=870525ec"
import script from "./OrderSuccess.vue?vue&type=script&lang=js"
export * from "./OrderSuccess.vue?vue&type=script&lang=js"
import style0 from "./OrderSuccess.vue?vue&type=style&index=0&id=870525ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports